<div class="drawer-container">
  <header class="drawer-header">
    <h2>Invite User</h2>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <form [formGroup]="inviteForm" (ngSubmit)="sendInvite()" class="drawer-form">
    <mat-label for="firstName" class="section-label">First Name</mat-label>
    <mat-form-field>
      <input matInput formControlName="firstName"/>
    </mat-form-field>

    <mat-label for="lastName" class="section-label">Last Name</mat-label>
    <mat-form-field>
      <input matInput formControlName="lastName"/>
    </mat-form-field>

    <mat-label for="email" class="section-label">Invite by Email</mat-label>
    <mat-form-field>
      <input matInput formControlName="email"/>
    </mat-form-field>

    <!-- Hidden as per TBYND 825 - will come back to this after launch -->
    <!--
    <div class="section-label">Assign Group</div>
    <mat-form-field  appearance="fill">
      <mat-label>Assign Group</mat-label>
      <mat-select formControlName="group">
        <mat-option *ngFor="let g of groups" [value]="g">{{ g }}</mat-option>
      </mat-select>
    </mat-form-field>

    <small class="hint">
      The default Group will be Admin. You can add another group prior to inviting.
    </small>
    -->
  </form>

  <footer class="drawer-footer">
    @if (inviteExists) {
      <small class="hint error">User already exists</small>
    }

    <button
      mat-raised-button
      color="primary"
      [disabled]="inviteForm.invalid || isSubmitting"
      (click)="sendInvite()">
      @if (!isSubmitting) {
        <span>Send Invite</span>
      }
      @if (isSubmitting) {
        <mat-spinner diameter="20" mode="indeterminate"></mat-spinner>
      }
    </button>
  </footer>

</div>
